import React, {useState, useEffect, useRef }  from 'react'
import {useHistory} from "react-router-dom"
import intl from 'react-intl-universal';
import '@/assets/css/goods.scss';
import { REQUEST} from "@/api";
import { queryString} from "@/util";
import {langPath} from "../../util";

const Goods = () => {
    const [offset, setOffset] = useState(10)
    const [offset2, setOffset2] = useState(10)
    const [stley1, setStyle1] = useState({})
    const [stley2, setStyle2] = useState({})
    const [query, setQuery] = useState({
        limit: 10,
        page: 1,
        type: intl.getInitOptions().currentLocale === 'zh-CN' ? '1' : '2'
    })
    const [hasCateId, setHasCatId ] = useState(0)
    const [hasCateType, setCateType ] = useState('c')
    const [loadMore, setLoadMore] = useState(true)
    const [scrollGoodsImg, setScrollGoodsImg] = useState('')

    const [goodsList, setGoodsList] = useState([])
    const [recommondGoodsList, setRecommondGoodsList] = useState([])

    const refBox1 = useRef()
    const refBox2 = useRef()
    const history = useHistory()
    const cateId = queryString('c') || ''
    const scrollBox1Fun = () => {
        let textBox = refBox1.current
        if (textBox) {
            if (Math.abs(offset) >= textBox.scrollWidth) {
                setOffset(0)
            }
            else {
                let step = -1.5
                setOffset(offset => offset + step)
                setStyle1({
                    transform: `translate3d(${offset}px, 0, 0)`
                })
            }
        }

    }
    const scrollBox2Fun = () => {
        let textBox2 = refBox2.current
        if (textBox2) {
            if (Math.abs(offset2) >= textBox2.scrollWidth) {
                setOffset2(0)
            }
            else {
                let step = -1.5
                setOffset2(offset2 => offset2 + step)
                setStyle2({
                    transform: `translate3d(${offset2}px, 0, 0)`
                })
            }
        }
    }
    const fetchGoodsList = (cateId, type) => {
        let data = {
            type : query.type,
            categoryId: type === 'c' ? cateId : '',
            styleId: type === 's' ? cateId : '',
            limit: query.limit,
            page: query.page,
            shelves: '1'
        }
        REQUEST('goodsListByCate', data).then((res) => {
            if (!scrollGoodsImg) {
                setScrollGoodsImg(res.body.list[0].categoryImage)
            }
            setGoodsList(goodsList => [...goodsList, ...res.body.list])
            const myQuery = query
            myQuery.page ++
            setQuery(myQuery)
            setLoadMore(res.body.list.length === query.limit)
            if (cateId) {
                requestAnimationFrame(scrollBox1Fun)
            }
        })
    }
    const fetchRecommondsList = (categoryId) => {
        const data = {
            categoryId,
            type: query.type
        }
        REQUEST('recommendByCategoryId', data).then((res) => {
            setRecommondGoodsList([...res.body])
        })
    }

    const resetQueryData = () => {
        const myQuery = Object.assign({}, {
            limit: 10,
            page: 1,
            type: intl.getInitOptions().currentLocale === 'zh-CN' ? '1' : '2'
        })
        setQuery(myQuery)
        setHasCatId('')
    }
    const goDetail = (val) => {
        let url = '/goods/' + val.goodsCode
        history.push(langPath(url))
    }
    const loadMoreGoods = (more) => {
        if (!more) return
        fetchGoodsList(hasCateId, hasCateType)

    }
    const changeCate = (item) => {
        history.push(langPath(`/goods?c=${item.id}&t=${hasCateType}`))
        window.location.reload()
        document.body.scrollTop = 0
        document.documentElement.scrollTop = 0
    }

    const initData = () => {
        resetQueryData()
        const categoryId = queryString('c') || ''
        const cateType = queryString('t') || ''
        setHasCatId(categoryId)
        setCateType(cateType)
        if (categoryId) {
            fetchGoodsList(categoryId, cateType)
            fetchRecommondsList(categoryId)
        }

    }

    useEffect(() => {
        if (queryString('c')) {
            requestAnimationFrame(scrollBox2Fun)
        }
    }, [offset2])
    useEffect(() => {
        initData()
    }, [cateId])
    useEffect(() => {
        if (queryString('c') && scrollGoodsImg) {
            requestAnimationFrame(scrollBox1Fun)
        }
    }, [offset])

    return (
        <div className="rl">
            <div className="rl-container rl-goods flex-column">
                <div className="rl-goods-scroll flex-row-start">
                    <div className="img-boxs flex-row-start" ref={refBox1} style={stley1}>
                        {
                            (
                                (hasCateId && scrollGoodsImg) &&
                                ( <div className="img-box">
                                    <img src={scrollGoodsImg} alt="" />
                                </div>)
                            )
                        }
                    </div>
                </div>
                <ul className="rl-goods-list">
                    {
                        goodsList.map(val => {
                            return (
                                <li className="rl-goods-item" key={val.id} onClick={() => goDetail(val)}>
                                    <div className="goods-item-img">
                                        <div className="img-box">
                                            <img src={val.image} alt=""/>
                                        </div>
                                    </div>
                                    <div className="goods-item-info flex-between">
                                        <div className="info-text flex-row-start">{ val.goodsName }</div>
                                        <div className="info-ctr">Click it</div>
                                    </div>
                                </li>
                            )
                        })
                    }
                </ul>
                <div className="rl-goods-more" onClick={() => loadMoreGoods(loadMore)}>
                    {
                        loadMore ? ('加载更多') : ('没有更多')
                    }
                </div>

                {
                    hasCateId && (
                        <div className="rl-goods-recommend flex-column">
                            <div className="rl-recommend-scroll flex-row-start">
                                <div className="img-boxs recommend flex-row-start" ref={refBox2} style={stley2}>
                                    <div className="img-box ">
                                        <img src="https://yunhong-rt.oss-cn-shanghai.aliyuncs.com/rt-mobile/goods/recommendation.png" alt="" />
                                    </div>
                                </div>
                            </div>
                            {
                                recommondGoodsList.length > 0 && (
                                    <div className="rl-recommend-list">
                                        <div className="recommend-item" onClick={() => changeCate(recommondGoodsList[0])}>
                                            <div className="img-box">
                                                <img src={recommondGoodsList[0].url} alt=""/>
                                            </div>
                                            <div className="img-info">{recommondGoodsList[0].name}</div>
                                        </div>
                                        <div className="recommend-item" onClick={() => changeCate(recommondGoodsList[1])}>
                                            <div className="img-box">
                                                <img src={recommondGoodsList[1].url} alt=""/>
                                            </div>
                                            <div className="img-info">{recommondGoodsList[1].name}</div>
                                        </div>
                                        <div className="recommend-tip flex-center">
                                            { intl.get('recommend') }
                                        </div>
                                    </div>
                                )
                            }
                        </div>
                    )
                }
            </div>
        </div>
    )
}
export default Goods
